

export const dateFormatter = (seconds) => {
  if (!seconds) return "";

  const date = new Date(Number(seconds) * 1000);

  if (isNaN(date.getTime())) return "";

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
};


export const formatToYYYYMMDD = (dateString) => {
  if (!dateString) return "";

  const [day, month, year] = dateString.split("/");
  if (!day || !month || !year) return "";

  return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
};
export const convertToTimestamp = (dateString) => {
  if (!dateString) return null;
  return new Date(dateString).getTime(); // returns ms
};

export const ddMMyyyyToSeconds = (dateString) => {
  if (!dateString) return null;

  const [day, month, year] = dateString.split("/");
  if (!day || !month || !year) return null;

  const date = new Date(
    Number(year),
    Number(month) - 1,
    Number(day)
  );

  return Math.floor(date.getTime() / 1000); 
};
